import {createContext} from 'react'

/**
 * Configuration file context
 */
export const ConfigContext = createContext(null)

